import HOSPITAL from "../../assets/Hospital - Iconly Pro.png";
import HEALTH from "../../assets/Health clipboard - Iconly Pro.png";
import MASK from "../../assets/Mask - Iconly Pro.png";
import PILLS from "../../assets/Pills - Iconly Pro.png";

import FLASH from "../../assets/Flash - Iconly Pro.png";
import SCALE from "../../assets/Scale - Iconly Pro.png";
import SITEMAP from "../../assets/Sitemap - Iconly Pro.png";

import HOSPITALSHEILD from "../../assets/Hospital shield - Iconly Pro.png";
import HOSPITALSYMBOL from "../../assets/Hospital symbol - Iconly Pro.png";
import MEDICALBAG from "../../assets/Medical bag - Iconly Pro.png";
import CHEMISTRYFLASK from "../../assets/Chemistry flask - Iconly Pro.png";

import FOLDER from "../../assets/Folder - Iconly Pro.png";
import DOCUMENTVERIFIED from "../../assets/Document verified - Iconly Pro (1).png";
import PROFILE from "../../assets/Profile - Iconly Pro.png";
import WRENCH from "../../assets/Wrench - Iconly Pro.png";
import HEDPHONE from "../../assets/Headphone - Iconly Pro.png";

import DOCUMENTSCAN from "../../assets/Document dash scan - Iconly Pro.png";
import USBSTORAGE from "../../assets/usb storage - Iconly Pro.png";
import STARS from "../../assets/Star - Iconly Pro.png";
import TIMER from "../../assets/Timer - Iconly Pro.png";

import SECTION3IMG from "../../assets/medical-section3-Img.png";
import SECTION8IMG from "../../assets/section8Img.png";
import SECTION7IMG from "../../assets/section7Img.png";
import SECTION2IMG from "../../assets/section2Img.png";
import HEROIMG from "../../assets/heroImg.png";

import MEDICAL_ASESSMENT from "../../assets/medical-asesment.png";
import MEDICAL_ASESSMENT_1 from "../../assets/medical-asesment-1.png";
import MEDICAL_ASESSMENT_2 from "../../assets/medical-asesment-2.png";
import MEDICAL_ASESSMENT_3 from "../../assets/medical-asesment-3.png";
import MEDICAL_ASESSMENT_4 from "../../assets/medical-asesment-4.png";
import MEDICAL_ASESSMENT_5 from "../../assets/medical-asesment-5.png";

export const IMAGES = {
    HOSPITAL,
    HEALTH,
    MASK,
    PILLS,
    FLASH,
    SCALE,
    SITEMAP,
    HOSPITALSHEILD,
    HOSPITALSYMBOL,
    MEDICALBAG,
    CHEMISTRYFLASK,
    FOLDER,
    DOCUMENTVERIFIED,
    PROFILE,
    WRENCH,
    HEDPHONE,
    DOCUMENTSCAN,
    USBSTORAGE,
    STARS,
    TIMER,
    SECTION3IMG,
    SECTION8IMG,
    SECTION7IMG,
    SECTION2IMG,
    HEROIMG,
    MEDICAL_ASESSMENT,
    MEDICAL_ASESSMENT_1,
    MEDICAL_ASESSMENT_2,
    MEDICAL_ASESSMENT_3,
    MEDICAL_ASESSMENT_4,
    MEDICAL_ASESSMENT_5
};
